﻿﻿import { IBackupPlan } from './backup-plan';

export interface IMoveTrackerRequest {
    tz: number;
    backupPlans: IBackupPlan[];
}
